import { TableColumn } from '../../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { PfizerPreTaskTemplate } from './pfizer-pre-task-template.model';

export class PfizerPreTaskTemplateListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string = '';


  id: string = '';
  templateTitle: string = '';


  constructor(data?: Partial<PfizerPreTaskTemplateListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new PfizerPreTaskTemplateListItem();
    const fieldMappings = PfizerPreTaskTemplate.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof PfizerPreTaskTemplateListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): PfizerPreTaskTemplateListItem {
    return new PfizerPreTaskTemplateListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      templateTitle: data.templateTitle || ''
    });
  }
} 